import { Api_Url } from './api'

export const pageTitle = 'Manage Journals'
export const subTitle = ''
export const apiUrl = Api_Url
